import {first} from "lodash";
import {makeAutoObservable, observable} from "mobx";
import {SelectChangeEvent} from "@mui/material";
import {inject, injectable} from "inversify";
import {AxiosError} from "axios";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {LOCALES} from "data/constants";
import {Locale, ModalType} from "data/enums";
import {extractErrorMessage} from "data/utils";
import {IApiResponse} from "data/services/http";
import {type IModalsStore} from "data/stores/modals/modals.store";

export interface ILanguageSelectController extends ViewController {
	readonly i18n: ILocalizationStore;
	readonly isLoading: boolean;

	get languages(): {lang: string; locale: string}[];

	handleChange: (e: SelectChangeEvent<unknown>) => void;
}

@injectable()
export class LanguageSelectController implements ILanguageSelectController {
	@observable isLoading: boolean = false;

	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private _modalStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get languages() {
		return LOCALES.map((locale) => ({
			locale,
			lang: first(locale.split("-")) as string,
		}));
	}

	handleChange = (e: SelectChangeEvent<unknown>) => {
		const load = async () => {
			try {
				this.isLoading = true;
				const locale = e.target.value as Locale;
				console.log(e, locale);
				await this.i18n.switchLocale({locale});
			} catch (error) {
				this._modalStore.showModal(ModalType.ERROR, {
					message: extractErrorMessage(error as AxiosError<IApiResponse>),
				});
			} finally {
				this.isLoading = false;
			}
		};

		void load();
	};
}
